export default __webpack_public_path__ + "static/media/menu.e05def23.svg";